"use client";

import { useEffect, useSyncExternalStore } from "react";
import { usePathname, useRouter } from "next/navigation";
import { useAuthContext } from "@core/helpers/client/contexts/AuthContext";
import { useWebSiteContext } from "@core/helpers/client/contexts/WebSiteContext";
import { build_login_url, is_logout_navigation_pending } from "@/helpers/accountAuth";

const subscribe_noop = () => () => { };

/**
 * گارد کلاینتی تب‌های پروفایل.
 *
 * ورود مستقیم بدون توکن را سرور در `page.jsx` به صفحه‌ی ورود ریدایرکت می‌کند.
 * این گارد حالت‌هایی را می‌پوشاند که صفحه از قبل باز است و توکن از بین می‌رود:
 * خروج از حساب در جای دیگر، توکن منقضی‌شده که AuthContext بعد از
 * getCurrentUser پاکش می‌کند، یا برگشت با دکمه‌ی بک به صفحه‌ی کش‌شده.
 */
const AccountAuthGuard = ({ children }) => {
  const { is_auth } = useAuthContext();
  const { web_route_names } = useWebSiteContext();
  const router = useRouter();
  const pathname = usePathname();

  // AuthContext توکن را با js-cookie می‌خواند که در سرور چیزی برنمی‌گرداند، پس
  // is_auth در SSR همیشه false است. تا قبل از hydrate به آن اعتماد نمی‌کنیم
  // (سرور خودش کوکی را چک کرده) وگرنه HTML سرور و کلاینت فرق می‌کرد.
  const hydrated = useSyncExternalStore(subscribe_noop, () => true, () => false);

  useEffect(() => {
    if (is_auth || is_logout_navigation_pending()) return;
    const return_path = `${pathname}${window.location.search}`;
    router.replace(build_login_url(web_route_names?.["auth"], return_path));
  }, [is_auth, pathname, web_route_names, router]);

  // محتوای پروفایل برای کاربر مهمان نمایش داده نمی‌شود
  if (hydrated && !is_auth) return null;
  return children;
};

export default AccountAuthGuard;
